import "./blogdashboardcomponent.css"

import blogMeta from "../../../data/blogmeta";

import { useLocation } from "wouter";

export default function BlogDashboardComponent() {
  const [, navigate] = useLocation();
  return (
    <div>
        {blogMeta.slice(0, 1).map((blog, index) => (
            <div 
            key={blog.id} 
            onClick={() => navigate(`/blogs/${blog.id}`)} 
            className="BlogDashboard">
              <div className="BlogDashboard-Img-Wrapper">
                <img src={blog.image} alt="" />
              </div>
              <div className="BlogDashboard-Details">
                <h3 className="">{blog.title}</h3>
                <p>{blog.description}</p>
                <a href="#">Know more</a>
              </div>
            </div>
        ))}
    </div>
  );
}
